<template>
    <div>
        <el-table
            :data="tableData"
            border
            style="width: 100%;
                margin-top:20px;">
            <el-table-column prop="createdAt" :label="$t('Common.time')" />
            <el-table-column prop="type" :label="$t('Setting.import_con')" />
            <el-table-column prop="remark" :label="$t('Setting.import_state')" />
            <el-table-column prop="insertCount" :label="$t('Setting.new_data')" />
            <el-table-column prop="updateCount" :label="$t('Setting.Update_data')" />
            <el-table-column prop="errorCount" :label="$t('Setting.err_data')">
                <template slot-scope="{row}">
                    {{ row.errorCount }}
                    <span
                        @click="handleError(row.errorReportUrl)"
                        class="cursor-pointer"
                        v-if="row.errorReportUrl">
                        {{ $t('Setting.download_errReport') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="operatorStaffNickname" :label="$t('Reception.Third.people')" />
        </el-table>
        <el-pagination
            v-if="tableData && tableData.length"
            class="text-right mt-10"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'import-history',
    data() {
        return {
            tableData: [],
            pagination: {
                size: 50,
                total: 0,
                page: 1,
            },
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            API.get('import/history', {
                params: {...this.pagination},
            }).then((res) => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            });
        },
        handleError(url) {
            window.open(url);
        },
    },
}
</script>
